import configurl from '@/config/user.env';
import { importApi, exportTempApi } from '@/modules/mdm/api/targetModdeules/scenarioReference.js';
export const importConfig = {
    action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
    downloadApi: exportTempApi,
    importApi: importApi,
    downParams: {
        fileName: '分场景-系统底表导入模板.xlsx',
        fileId: 'goalScenarioSystemBaseImport.xlsx'
    },
    multiple: false,
    accept: '.xlsx,.xls',
    limtSizeKey: 'goalScenarioSystemBaseImport',
    downBtn: true,
    showFileList: false,
    fileType: '只能上传Excel文件',
    manualUpload: true
};
